<template>
  <div>
    <div class="select-field">
      <v-select ref="COMBO_BOX"
                v-model=choix
                :class="getEditFieldClass"
                :filter="removeAccents"
                :items=items
                :ripple="false"
                :placeholder="selectPlaceHolder">
      </v-select>
    </div>

    <div v-if="hasTextArea" class="select-field">
      <v-textarea v-model=saisieOther
                  :class="getEditFieldClass"
                  :ripple="false"
                  :maxlength=textMaxLength
                  :placeholder="textPlaceholder"
                  @keydown.enter.stop>
      </v-textarea>
    </div>
  </div>
</template>

<script lang="ts">
  import Item from '@/framework/base/classes/Item';
  import { ReasonSelect, ReasonChoix } from '@/generated/classes/Dialog';
  import { EditFieldTheme } from '@/framework/base/components/FieldInfo';
  import latinize from 'latinize';
  import { defineComponent, type PropType } from "vue";

  export const SELECT_NEW_VALUE = -1;
  export const SELECT_VALUE = -999;
  export const SELECT_TEXT = 'Sélectionner';

  export default defineComponent({
    components: {},
    props: {
      ReasonSelect: {
        type: Array as PropType<ReasonSelect>,
        required: true
      },
      bold: {
        type: Boolean
      },
      dataTable: {
        type: Boolean
      },
    },
    data () {
      return {
        label: '',
        hasTextArea: false,
        value: 0,
        text: '',
        selectPlaceHolder: 'Sélectionner',
        textPlaceholder: 'Merci de préciser (de 10 à 200 caractères)',
        textMinLength: 10,
        textMaxLength: 200,
      };
    },

    computed: {
      EditFieldTheme () {
        return EditFieldTheme;
      },
      choix: {
        get (): string {
          let value = this.selectPlaceHolder;
          if (this.ReasonSelect.value > 0 && this.ReasonSelect.choix.length >= this.ReasonSelect.value) {
            const choix = this.ReasonSelect.choix[this.ReasonSelect.value - 1];
            value = choix.label;
            this.hasTextArea = choix.hasTextArea;
          }
          return value
        },
        set (value: string) {
          const reason = this.ReasonSelect.choix.find(a => a.label == value);
          if (reason) {
            this.hasTextArea = reason.hasTextArea;
            this.value = this.ReasonSelect.choix.indexOf(reason) + 1;
            const updated = this.ReasonSelect.value != value;
            if (updated) {
              this.ReasonSelect.value = this.value;
              this.ReasonSelect.valid = !this.hasTextArea || !reason.textRequired || (this.text.length >= this.textMinLength && this.text.length <= this.textMaxLength);
              this.$emit('updated', this.ReasonSelect);
            }
          }
        }
      },
      saisieOther: {
        get (): string {
          return this.ReasonSelect.text;
        },
        set (text: string) {
          this.text = text;
          this.ReasonSelect.text = this.text;
          this.ReasonSelect.value = this.value;
          const reason = this.ReasonSelect.choix[this.value-1]
          this.ReasonSelect.valid = !reason.textRequired || (this.text.length >= this.textMinLength && this.text.length <= this.textMaxLength);
          this.$emit('updated', this.ReasonSelect);
        }
      },
      items (): Item[] {
        const res: Item[] = [];
        let index = 1;
        this.ReasonSelect.choix.forEach((choix: ReasonChoix) => {
          res.push(new Item(index++, choix.label))
        });
        return res;
      },

      getEditFieldClass (): string {
        let res = 'edit-field';
        if (this.bold) {
          res = 'edit-field-bold';
        }
        if (this.dataTable) {
          res += ' data-table-custom';
        }
        return res;
      }
    },
    created (): void {
      this.value = this.ReasonSelect.value;
      this.text = this.ReasonSelect.text;
      if (this.ReasonSelect.selectPlaceholder != '') {
        this.selectPlaceHolder = this.ReasonSelect.selectPlaceholder;
      }
      if (this.ReasonSelect.textMinLength > 0) {
        this.textMinLength = this.ReasonSelect.textMinLength;
      }
      if (this.ReasonSelect.textMaxLength > 0) {
        this.textMaxLength = this.ReasonSelect.textMaxLength;
      }
      if (this.ReasonSelect.textPlaceholder != '') {
        this.textPlaceholder = this.ReasonSelect.textPlaceholder;
      } else if (this.ReasonSelect.textMinLength > 0 || this.ReasonSelect.textMaxLength > 0) {
        this.textPlaceholder = 'Merci de préciser (de ' + this.textMinLength + ' à ' + this.textMaxLength + ' caractères)'
      }
    },
    methods: {
      setFocus (): void {
        // @ts-expect-error : generated method
        this.$refs.COMBO_BOX.focus();
      },
    }
  })

</script>
